import React from 'react';
import SbEditable from 'storyblok-react';
import TextCard from '~/components/Dynamic/TextCard';
import Counter from '~/components/Counter';

export default function TwoColCountupStats({ blok }) {
  const hasTextCard = blok?.textCard?.length > 0;
  return (
    <SbEditable content={blok}>
      <section className={`my-20 md:my-28 ${blok.className}`}>
        <div className="container">
          <div className="flex flex-wrap -ml-20 lg:-ml-44 relative">
            {hasTextCard && (
              <div className="w-full pl-20 lg:w-6/12 lg:pl-44">
                <div className="sticky top-[8.75rem]">
                  <TextCard
                    blok={{
                      ...blok.textCard[0],
                      headingClass: `font-extrabold max-w-md ${blok.textCard[0].headingClass}`,
                      contentClass: `text-20px ${blok.textCard[0].contentClass}`,
                    }}
                  />
                </div>
              </div>
            )}
            <div className={`w-full pl-20 mt-12 ${hasTextCard ? 'lg:w-6/12': 'grid grid-cols-1 md:grid-cols-2 md:gap-6'} lg:pl-44 lg:mt-0`}>
              {blok.stats.map((stat) => (
                <SbEditable content={stat}>
                  <Counter key={stat._uid} {...stat} />
                </SbEditable>
              ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  );
}
